import styled from 'styled-components'

import { flex } from '@/styles/flex'
import { sizing } from '@/styles/sizing'

import { zLayers } from '@/utils/styling/zLayers'

export const Canvas = styled.div`
  ${flex}
  ${sizing}
  z-index: ${zLayers.default};
  overflow: auto;
`
